import { AddMemberResponse, MemberPagesResponse, MemberResponse, MemberSessionList, ResetMemberPasswordResponse, RevokeSessionsResponse, SalespersonList, TeamList, } from '@aeris/contracts';
import { request } from "./client.js";
/**
 * `/api/v1/team` — quem tem acesso ao tenant, com que papel e em que telas.
 *
 * Duas coisas voltam UMA vez só e nunca de novo: a senha temporária de quem é
 * adicionado e a senha redefinida. Não existe segunda requisição que as peça —
 * o banco guarda o hash.
 */
const teamParams = (query) => {
    const params = new URLSearchParams();
    if (query.search !== undefined && query.search.length > 0) {
        params.set('search', query.search);
    }
    if (query.status !== undefined)
        params.set('status', query.status);
    if (query.role !== undefined)
        params.set('role', query.role);
    if (query.page !== undefined)
        params.set('page', String(query.page));
    if (query.pageSize !== undefined) {
        params.set('pageSize', String(query.pageSize));
    }
    if (query.sort !== undefined)
        params.set('sort', query.sort);
    if (query.direction !== undefined)
        params.set('direction', query.direction);
    const encoded = params.toString();
    return encoded.length > 0 ? `?${encoded}` : '';
};
/**
 * Os nomes que podem ser escolhidos como vendedor no PDV.
 *
 * Endpoint próprio, mais magro que `/team/members` e atrás de outra permissão:
 * quem opera o balcão pode escolher quem atendeu sem poder ver a ficha
 * administrativa da equipe.
 */
export const fetchSalespeople = async (signal) => SalespersonList.parse(await request('/api/v1/team/salespeople', { signal }));
export const fetchTeam = async (query, signal) => TeamList.parse(await request(`/api/v1/team/members${teamParams(query)}`, { signal }));
/**
 * Adds somebody, and returns their temporary password once.
 *
 * The caller must show it immediately: there is no second request that can ask
 * for it again, by design. See docs/features/F011-team.md.
 */
export const addMember = async (input) => AddMemberResponse.parse(await request('/api/v1/team/members', { method: 'POST', body: input }));
export const changeMemberRole = async (userId, input) => MemberResponse.parse(await request(`/api/v1/team/members/${userId}/role`, {
    method: 'PATCH',
    body: input,
}));
export const setMemberEnabled = async (userId, enabled, version) => MemberResponse.parse(await request(`/api/v1/team/members/${userId}/${enabled ? 'enable' : 'disable'}`, { method: 'POST', body: { version } }));
export const resetMemberPassword = async (userId) => ResetMemberPasswordResponse.parse(await request(`/api/v1/team/members/${userId}/password-reset`, {
    method: 'POST',
}));
/**
 * As telas de uma pessoa (F038).
 *
 * `available` é o que o papel dela alcança; `allowed`, o que sobrou depois do
 * que o admin tirou. A tela precisa dos dois: o que o papel não inclui aparece
 * desmarcado e travado, em vez de sumir.
 */
export const fetchMemberPages = async (userId, signal) => MemberPagesResponse.parse(await request(`/api/v1/team/members/${userId}/pages`, { signal }));
export const setMemberPages = async (userId, allowed) => MemberPagesResponse.parse(await request(`/api/v1/team/members/${userId}/pages`, {
    method: 'PUT',
    body: { allowed: [...allowed] },
}));
export const fetchMemberSessions = async (userId, signal) => MemberSessionList.parse(await request(`/api/v1/team/members/${userId}/sessions`, { signal }));
export const revokeMemberSessions = async (userId, sessionId) => RevokeSessionsResponse.parse(await request(sessionId === undefined
    ? `/api/v1/team/members/${userId}/sessions`
    : `/api/v1/team/members/${userId}/sessions/${sessionId}`, { method: 'DELETE' }));
//# sourceMappingURL=team.js.map